import "./PPZoneBodyInstitutionWing.module.css";
import NewsHero from "@/pages/PPZone/sections/NewsHero";
import OrganizationalHero from "./sections/OrganizationalHero";
import OrganizationalBodiesGrid from "./sections/OrganizationalBodiesGrid";
import Footer from "@/reusable_sections/Footer";
export default function PPZoneBodyInstitutionWingPage() {
  return <div>
      <NewsHero activeMenuItem="/zona-pp/badan-lembaga-sayap" />
      <OrganizationalHero />
      <OrganizationalBodiesGrid />
      <Footer />
    </div>;
}